import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";
import { SkillsTable } from "@/components/skills/SkillsTable";

export function SkillsPage() {
  useSetBreadcrumbs([{ label: "Capability" }, { label: "Skills" }]);

  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Capability"
        title="Skills"
        description="The library of skills and their competency levels."
      />
      <SkillsTable />
    </div>
  );
}
